import { useEffect, useRef, useState } from 'react'

const useContainerSize = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const container = containerRef.current

    if (!container) return

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect
      setSize({ width, height })
    })
    observer.observe(container)

    return () => observer.unobserve(container)
  }, [containerRef.current])

  return { size, containerRef }
}

export default useContainerSize
